import { useReadContract } from "wagmi";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import { DisplayValue, Typography } from "../../../../shared";

export const DisplayMintPaused: React.FC = () => {
  const { data: mintPaused, ...rest } = useReadContract({
    abi: ArbitrageAbi,
    address: contractAddresses.Arbitrage,
    functionName: "mintPaused",
  });

  return (
    <div className="flex flex-row gap-2">
      <Typography>Mint Paused:</Typography>
      <DisplayValue viewValue={mintPaused ? "Yes" : "No"} {...rest} />
    </div>
  );
};
